export class Exchange {
  idExchange: number;
  code: string;
  locked: boolean;
  blockStore: boolean;
  blockStream: boolean;

  constructor(
    idExchange: number,
    code: string,
    locked: boolean,
    blockStore: boolean,
    blockStream: boolean,
  ) {
    this.idExchange = idExchange;
    this.code = code;
    this.locked = locked;
    this.blockStore = blockStore;
    this.blockStream = blockStream;
  }

  static fromRaw(raw: any): Exchange {
    return new Exchange(
      raw.idExchange,
      String(raw.code),
      Boolean(raw.locked),
      Boolean(raw.blockStore),
      Boolean(raw.blockStream),
    );
  }

  clone(): Exchange {
    return new Exchange(
      this.idExchange,
      this.code,
      this.locked,
      this.blockStore,
      this.blockStream,
    );
  }

  toPayload(): any {
    const payload: any = {
      idExchange: this.idExchange,
      code: this.code,
      locked: this.locked,
      blockStore: this.blockStore,
      blockStream: this.blockStream,
    }
    if (payload.code === '') {
      payload.code = null;
    }

    return payload;
  }
}
